const accountModule = {
  namespaced: true,
  state: {
    searchForm: {
      account: '',
      name: '',
      role: '所有'
    },
    dataList: [],
    operateData: {}
  },
  getters: {
    getSearchForm: (state) => state.searchForm,
    getDataList: (state) => state.dataList,
    getOperateData: (state) => state.operateData
  },
  mutations: {
    setSearchForm(state, formData) {
      state.searchForm = formData
    },
    clearSearchForm(state) {
      state.searchForm = {
        account: '',
        name: '',
        role: '所有'
      }
      state.dataList = []
    },
    setDataList(state, newDataList) {
      state.dataList = newDataList
    },
    // setOperateData(state, row) {
    //   console.log(row)
    //   state.operateData = row
    // }
  },
  actions: {
    search({ commit }) {
      // TODO: API

      const searchResult = Array.from({ length: 10 }).map(() => ({
        // TODO: 待串接資料移除假資料
        id: Math.floor(Math.random() * 900) + 100,
        fullname: '王ＸＸ',
        account: 'abcXXX',
        email: `abc${Math.floor(Math.random() * 900) + 100}@gmail.com`,
        tel: `0912-${Math.floor(Math.random() * 900) + 100}123`,
        roleRight: Math.random() < 0.5 ? '社區管理員' : '秘書'
      }))

      // 更新 dataList
      commit('setDataList', searchResult)
    },
    clearSearch({ commit }) {
      // Clear the search form by calling the clearSearchForm mutation
      commit('clearSearchForm')
    }
  }
}

export default accountModule
